<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row">
        <div class="col-md-2 col-4 mt-5">
          <a :href="resolve('user.details')"
             @click="navigate('user.details', $event)"
             v-html="arrowLeftSVG" />
        </div>
        <div class="offset-md-1 col-md-6 col-8 mt-5">
          <h1>Delete Account</h1>
        </div>
      </div>

      <div class="row mb-5">
        <div class="offset-md-3 col-md-6 mt-5">
          <b-alert v-for="err in errors" :key="err" variant="danger" show>
            {{ err }}
          </b-alert>
          <p class="mb-5">
            This is a permanent action and it cannot be undone by anyone ever. All information associated
            with this account will be deleted. If you wish to continue then please enter your password
            below.
          </p>
          <b-form @submit="onSubmit">
            <b-form-group label="Your Password" label-for="password" label-cols-md="3">
              <b-form-input
                  id="password"
                  v-model="user.password"
                  type="password"
                  placeholder="Enter your password"
              />
            </b-form-group>
            <b-button type="submit" variant="primary"
                      :pressed="submitting"
                      :disabled="submitting || user.password === ''">
              DELETE MY ACCOUNT
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import apiMixin from "../../utils/api"
import Footer from "../navigation/Footer"
import NavBar from "../navigation/Navbar"
import octicons from "@primer/octicons"

export default {
  name: 'UserDelete',
  components: {Footer, NavBar},
  mixins: [apiMixin],
  data() {
    return {
      user: {
        password: ""
      },
      error: null,
      submitting: false,

      arrowLeftSVG: octicons["arrow-left"].toSVG({height: '40px'})
    }
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault()
      this.success = false
      this.submitting = true

      try {
        await this.delete("/api/users/me/", this.user, false)
        await this.$router.push({name: 'user.login'})
      } catch (e) {
        this.submitting = false
        this.catchApiError(e, false)
      }

    }
  }
}
</script>

<style>
</style>
